/* global YT */
(function ($) {
  $(function () {
    var youtubeVideo = $(".js-youtube");

    if (youtubeVideo.length > 0) {
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      tag.async = true;
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    // Video embed in content
    var playerDefault;
    var ytplayerDefault = document.querySelectorAll(".js-ytEmbed");

    // Video embed in carousel with loop

    for (var i = 0; i < ytplayerDefault.length; i++) {
      var videoOverlapping = ytplayerDefault[i].closest("section");

      if (videoOverlapping) {
        videoOverlapping.getElementsByClassName(
          "js-toggle-show-class-testimonial"
        );
      }

      ytplayerDefault[i].addEventListener("click", function () {
        var elemID = this.id;
        var elemDataEmbed = this.dataset.embed;

        if (this.closest("section")) {
          var ytplayerCarousel = this.closest("section").querySelectorAll(
            ".js-ytEmbedCarousel"
          );
        }

        if (windowWidth <= "767" && ytplayerCarousel.length > 0) {
          // Video embed in carousel with loop
          var activeFrame = $(".swiper-slide-visible").find(
            ".js-ytEmbedCarousel"
          );
          var activeFrameDataSetEmbed = activeFrame.data("embed");
          var tempId = "yt-" + this.id;
          activeFrame.attr("id", tempId);
          elemID = tempId;
          elemDataEmbed = activeFrameDataSetEmbed;
        }

        const swiperPagination =
          this.closest("section") &&
          this.closest("section").querySelector(".swiper-pagination");
        if (swiperPagination) {
          swiperPagination.classList.add("pe-none");
        }

        playerDefault = new YT.Player(elemID, {
          height: "",
          width: "",
          videoId: elemDataEmbed,
          events: {
            onReady: onPlayerReady,
          },
        });

        window[elemDataEmbed] = playerDefault;

        function onPlayerReady() {
          playerDefault.playVideo();
        }
      });

      //Video testimonial add shown class when clicked on video, remove when clicked outside the video
      if (videoOverlapping && videoOverlapping.length > 0) {
        videoOverlapping[0].addEventListener("click", function (e) {
          let target = $(e.target);

          if (target.is(".js-video-show-toggler")) {
            this.classList.add("shown");
          } else if (this.classList.contains("shown")) {
            this.classList.remove("shown");
            playerDefault.destroy();
          }
        });
      }
    }

    // Video in Bootstrap modal

    // vars
    var playerModal;
    var windowWidth = $(window).width();
    var videoModal = $("#video-modal");

    if (windowWidth >= "992") {
      $(".play-button-modal").on("click", function () {
        $("html, body").css("-webkit-overflow-scrolling", "auto");
      });
    }

    videoModal.on("show.bs.modal", function () {
      // on opening the modal

      var ytplayer = document.querySelector(".ytIframe");

      playerModal = new YT.Player(ytplayer.id, {
        height: "",
        width: "",
        videoId: ytplayer.dataset.embed,
        events: {
          onReady: onPlayerReady,
        },
      });

      function onPlayerReady() {
        playerModal.playVideo();
      }
    });

    videoModal.on("hidden.bs.modal", function () {
      // on closing the modal

      videoModal.off(
        "webkitAnimationEnd oanimationend msAnimationEnd animationend"
      );

      // stop the video
      playerModal.destroy();
    });

    // Fullscreen mode on youtube player
    function fullscreenClass() {
      $("body").addClass("video-full-screen");
    }

    $(document).on(
      "webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange",
      fullscreenClass
    );
  });

  $("body").on("click", ".js-play-button--html-video", function () {
    const video = $(this).siblings("video");

    $(this).fadeOut(0);

    if (video[0]) {
      video[0].play();
    }
  });
})(jQuery);
